<template>
  <v-app-bar app dense>

		<v-spacer/>
		
		<v-avatar v-if="user_data && user_data.srru_data">
			<v-img
				:src="`https://mis.srru.ac.th${user_data.srru_data.img}`"
				height="40"
				max-width="32"
			></v-img>
		</v-avatar>
		<v-subheader v-if="user_data && user_data.srru_data">{{ `${user_data.srru_data.ref_prefix_name.initials}${user_data.srru_data.stf_fname} ${user_data.srru_data.stf_lname}` }}</v-subheader>
		<v-btn tile color="primary" icon @click="logout">
			<v-icon>mdi-logout</v-icon>
		</v-btn>
  </v-app-bar>
</template>

<script>
export default {
	computed: {
    user_data() { return this.$store.state.auth.user_data },
	},
	methods: {
		logout() {
			this.$store.dispatch('auth/logout').then(() => {
				this.$router.push({ name: 'Login' });
			})
		}
	}
}
</script>